'use strict';

//Utility
var React = require('react');

//Actions
var AdviceFeeAction = require('../../actions/AdviceFeeAction.js');
var SuperFirstTransferAction = require('../../actions/SuperFirstTransferAction.js');

//Store
var AdviceFeeStore = require('../../stores/AdviceFeeStore.js');

//Components
var SectionHeader = require('../Common/SectionHeader.jsx');
var RadioInput = require('../Common/RadioInput.jsx');
var Spinner = require('../Common/Spinner.jsx');

//Constants
var ApplicationConstants = require('../../constants/ApplicationConstants');

function getStateFromStores() {
    return {               
        finishedAdviserFee: AdviceFeeStore.finishedAdviserFee(),
        adviceFeeErrorList: AdviceFeeStore.adviceFeeErrorMessages(),
        isSuperTransfer: AdviceFeeStore.isSuperTransferSetup(),        
        model: AdviceFeeStore.getAdviceFeeModelData(),
        formError: AdviceFeeStore.getFormError(),        
        feeTypeEnableOption: AdviceFeeStore.getFeeTypeEnableOption(),
        isLoadingComplete: AdviceFeeStore.getIsLoadingComplete(),
        showPredictiveSearch: AdviceFeeStore.getShowPredictiveSearch(),
        isOneOffFeeExist: AdviceFeeStore.getIsOneOffFeeExist()
    };
}

var AdviceFeeSection = React.createClass({
    getInitialState: function () {
        return getStateFromStores();
    },
    componentDidMount: function () {
        AdviceFeeStore.addChangeListener(this._onChange);
    },

    componentWillUnmount: function () {
        AdviceFeeStore.removeChangeListener(this._onChange);
    },

    _onChange: function () {
        this.setState(getStateFromStores());
    },

    componentDidUpdate: function () {
        ApplicationConstants.FormModel.form.adviceFee.adviceFeeOption = this.state.model.adviceFeeOption;
    },

    componentWillUpdate: function (nextProps, nextState) {
        if (nextState.isOneOffFeeExist !== this.state.isOneOffFeeExist) {
            SuperFirstTransferAction.updateIsAdviceFeeOneOffExist(nextState.isOneOffFeeExist);
        }
    },

    addAdviserFee: function (e) {

        let fieldId = e.target.model,
            value = e.target.value;
        if (this.state.model[fieldId] !== value) {
            AdviceFeeAction.addAdviserFee(fieldId, value);
        }
    },

    removeSingleRecord: function (index, event) {
        if (event) {
            event.preventDefault();
        }
        AdviceFeeAction.removeSingleRecord(index);
    },

    render: function () {
        var feeTypeEnableOption = this.state.feeTypeEnableOption;

        if (feeTypeEnableOption === 3) {
            return null;
        }
        var showAdviceFeeSection = this.state.model.adviceFeeOption === ApplicationConstants.YesNoValues.YES;
        


        return (
            <div className="form-step" id="adviser-fee-section">
                <SectionHeader focus={this.props.focus} sectionName="Advice fees" sectionHelpText={this.props.content.common.sectionHeaderHelp} NeedHelpInfo={this.props.content.adviceFees.adviceFeeHelp} />
                <div className="container">
                    <div className="form-section form-autocomplete">

                        <span className="form-label-section">
                            <label>Complete this section only if you have agreed with your financial adviser to have advice fees deducted. Refer to the PDS for details.</label>
                        </span>

                        <span className="form-label-section">
                            <label className="pull-right adviser-optional">(Optional)</label>
                        </span>

                        <RadioInput id="advFee_adviceFeeOption_0"
                                    label="Would you like to add an advice fee?"
                                    model="adviceFeeOption"
                                    data={ApplicationConstants.YesNoRadioData}
                                    value={this.state.model.adviceFeeOption}
                                    onChange={this.addAdviserFee}
                                    errorList={this.state.formError} />

                        { showAdviceFeeSection ?
                                    <section>                                       
                                       <div className="form-label-section">                           
                                            <label>Please follow the link at the end of this application to set up an Adviser Service Fee on this account.</label>
                                             <div className="spacing__container"></div>
                                        </div>
                                     </section>                                                                                                  
                         : null }
                        {this.state.isLoadingComplete ? null :(<Spinner size={ApplicationConstants.SpinnerSizes.Three}/>)}
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = AdviceFeeSection;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AdviserFee/AdviceFeeSection.jsx